export const version="0.2.0"
export const build = 224

export const project = {
    "dev":"Narravero DEV",
    "test":"Narravero TEST",
    "prod":"Narravero"
}
